module.exports = __webpack_public_path__ + "images/dusk-49d6a016431f02dcf8f18ee4af9702f0.jpg";